/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
import { dilation2d } from '../../ops/dilation2d';
import { Tensor } from '../../tensor';
Tensor.prototype.dilation2d = function (filter, strides, pad, dilations, dataFormat) {
    this.throwIfDisposed();
    return dilation2d(this, filter, strides, pad, dilations, dataFormat);
};
//# sourceMappingURL=dilation2d.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@tensorflow/tfjs-core/dist/public/chained_ops/dilation2d.js
// module id = 1487
// module chunks = 0